import { post } from '../axios'

// 查询所有已审核的发表的站内信
export function v1_station_letter_index_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/station-letter/index`,
    map,
    option
  ).then(response => response)
}

// 创建站内信
export function v1_station_letter_create_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/station-letter/create`,
    map,
    option
  ).then(response => response)
}

// 审核消息
export function v1_station_letter_audit_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/station-letter/audit`,
    map,
    option
  ).then(response => response)
}

// 查询所有未审核列表
export function v1_station_letter_unAudit_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/station-letter/unAudit`,
    map,
    option
  ).then(response => response)
}
